import React from 'react';

const Agenda = ({agentInfo}) => {

    return (
        <div className="col-md-4" >
        <div className="agenda-card">
          <div className="d-flex justify-content-between">
          <small className="secondary-text ">{agentInfo?.timing}</small>
          {/* <small className="secondary-text ">{info.duration}</small> */}
          <small className="secondary-text ">{agentInfo?.session_type}</small>
          </div>
            <h6>{agentInfo?.session_title}</h6>
            <p className="m-0">{agentInfo?.speaker_name}</p>
        </div>
        </div>
    );
};

export default Agenda;